import React, { useEffect, useState } from "react";
import style from "./userPackages.module.scss";
import Skeleton from "../skeleton/skeleton"
{/* <Skeleton type='rectangle' width='280px' height='44px' /> */ }
const PackageSkeleton = (props) => {

    return <div className={style.wrapper}>
        <h1 style={{ display: 'flex', justifyContent: 'flex-end' }}><Skeleton type='rectangle' width='170px' height='34px' /></h1>
        <div className={style.tabel}>
            <div className={style.row} style={{ justifyContent: 'space-between' }}>
                <Skeleton type='rectangle' width='19%' height='500px' />
                <Skeleton type='rectangle' width='19%' height='500px' />
                <Skeleton type='rectangle' width='19%' height='500px' />
                <Skeleton type='rectangle' width='19%' height='500px' />
                <Skeleton type='rectangle' width='19%' height='500px' />
            </div>
            <div className={style.row} style={{ justifyContent: 'space-between', marginTop: '15px' }}>
                <Skeleton type='rectangle' width='19%' height='28px' />
                <Skeleton type='rectangle' width='19%' height='28px' />
                <Skeleton type='rectangle' width='19%' height='28px' />
                <Skeleton type='rectangle' width='19%' height='28px' />
                <Skeleton type='rectangle' width='19%' height='28px' />
            </div>
            <div className={style.priceRow}>
                <div className={style.rightBox}></div>
                <div className={style.priceBoxWrapper}><Skeleton type='rectangle' width='92px' height='44px' /></div>
                <div className={style.priceBoxWrapper}><Skeleton type='rectangle' width='92px' height='44px' /></div>
                <div className={style.priceBoxWrapper}><Skeleton type='rectangle' width='92px' height='44px' /></div>
                <div className={style.priceBoxWrapper}><Skeleton type='rectangle' width='92px' height='44px' /></div>
            </div>
        </div>
    </div>
}
export default PackageSkeleton;
